import { formatPrecipChance, formatPrecipType, formatTemperature, roundNearest5 } from './DataFormatting';
import {
  getDspAccessToken,
  getDspAuthHeader,
  getDspClientToken,
  refreshDspAccessToken,
  refreshDspClientToken,
} from './DspAuth';
import { getContentLibrary } from './getContentLibrary';
import { startConnectionListener } from './getDeviceConnectionState';
import { getDeviceVolume } from './getDeviceVolume';
import { getSegmentDisplayName } from './getSegmentDisplayName';
import { getSignupUrl } from './getSignupUrl';
import { getSubscriptionType } from './getSubscriptionType';
import { getForecastWeatherPhrase, getWeatherPhrase } from './getWeatherPhrase';
import { getDeviceKey, resetDeviceKey } from './KeyUtils';
import {
  canManageSubscriptionsOnPlatform,
  canPurchaseOnPlatform,
  DEBUG,
  getTizenVersion,
  isAndroid,
  isFireTV,
  isGoogleTV,
  isTizen,
  isTVOS,
  isVizio,
  isWeb,
  isWebkit,
  isX1,
  platformName,
} from './Platform';
import {
  refetchIntervalAt3pAnd3a,
  refetchIntervalByEndOfHour,
  refetchIntervalByExpirationTime,
  refetchIntervalFallback,
} from './refetchIntervalUtils';
import { getStorageItem } from './storage';
import {
  accessibleCode,
  accessibleDollarAmount,
  accessibleTime,
  accessibleURL,
  displayString,
  getThumbnailUrl,
  isDisplayable,
  missingValue,
  replaceAllInString,
  replaceTemplateValues,
  toQueryString,
} from './StringUtils';
import { TimeUtils } from './TimeUtils';
import { FOCUS_NOW } from './Tools';
import { transformObjectWithLinearFeedsToANF } from './transformObjectWithLinearFeedsToANF';
import { Units } from './Units';
import { attachParams, getBaseURL, getParamsFromUrl } from './urlTools';
import { verifyAppInstalled } from './verifyAppInstalled';

export const helpers = {
  getContentLibrary,
  formatPrecipChance,
  formatPrecipType,
  formatTemperature,
  roundNearest5,
  getDspAccessToken,
  getDspAuthHeader,
  getDspClientToken,
  refreshDspAccessToken,
  refreshDspClientToken,
  startConnectionListener,
  getDeviceVolume,
  getSubscriptionType,
  getForecastWeatherPhrase,
  getWeatherPhrase,
  getDeviceKey,
  resetDeviceKey,
  DEBUG,
  canManageSubscriptionsOnPlatform,
  canPurchaseOnPlatform,
  getTizenVersion,
  isAndroid,
  isFireTV,
  isGoogleTV,
  isTVOS,
  isTizen,
  isVizio,
  isWeb,
  isWebkit,
  isX1,
  platformName,
  refetchIntervalAt3pAnd3a,
  refetchIntervalByEndOfHour,
  refetchIntervalByExpirationTime,
  refetchIntervalFallback,
  accessibleCode,
  accessibleDollarAmount,
  accessibleTime,
  accessibleURL,
  displayString,
  getThumbnailUrl,
  isDisplayable,
  missingValue,
  replaceAllInString,
  replaceTemplateValues,
  toQueryString,
  TimeUtils,
  FOCUS_NOW,
  Units,
  verifyAppInstalled,
  getStorageItem,
  attachParams,
  getBaseURL,
  getParamsFromUrl,
  getSignupUrl,
  getSegmentDisplayName,
  transformObjectWithLinearFeedsToANF,
};
